import storage from 'didi-store'
import { prefixUrl, request, SodaGlobalParams } from '@/common/utils/request'
import { getLocation } from '@/common/utils/geo'
import * as api from '@/api'
import { get } from 'lodash-es'
import { i18n } from '@/common/utils/i18n'
import { trackEvent } from '@/common/utils/log'
import { formatDateTime } from '@didi/elvish-lib-javascript'

export default {
  // 获取首页基本数据（任务列表，城市筛选）
  getSummary({ commit, state, getters }, payload) {
    let params = {
      ...getters.areaGroup,
      ...getters.geo
    }
    return Promise.all([
      api.fetchTaskIndex(params).then(res => {
        commit('updateTaskIndex', res.data)
      })
      // api.fetchHomeSummary(params).then(res => {
      //   commit('updateSummary', res.data)
      //   return res.data
      // }),
    ])
  },
  // 获取首页 商户运营、商家签约信息
  getSummaryOther({ commit, state, getters }, payload) {
    let { areaWatch = false, tabIndex } = payload
    let params = {
      ...getters.areaGroup,
      ...getters.geo
    }
    // tabIndex 从1开始
    let list = [
      function() {},
      function() {},
      function() {
        return api.fetchOnboardingIndex(params).then(res => {
          commit('updateOnboardingIndex', res.data)
        })
      },
      function() {
        return api.fetchEngagementIndex(params).then(res => {
          commit('updateEngagementIndex', res.data)
        })
      }
    ]
    let promiseList = !areaWatch
      ? []
      : [
          api.fetchBizoppTitle(params).then(res => {
            // 这里拿到签约状态的数值
            commit('updateCountByStatus', res.data)
            return res.data
          })
        ]
    list[tabIndex] && promiseList.push(list[tabIndex]())
    return Promise.all(promiseList)
  },
  getQuickList({ commit, state, rootGetters }, params) {
    return api
      .fetchTaskIndexList({
        ...rootGetters.areaGroup,
        ...rootGetters.geo,
        ...params,
        status: null
      })
      .then(res => {
        commit('updateTaskIndexList', res.data)
        return res.data
      })
  },
  // 获取金刚位信息
  async getVajraQuickLink({ commit, state }, params = {}) {
    const vajraListData = await api.getVajraQuickLink(params)
    commit('updateVajraListData', vajraListData)
  },
  updateLoginData({ commit, state }, payload) {
    storage.set('ticket', payload.ticket)
    storage.set('uname', payload.uname)
    commit('updateLogin', payload)
  },
  async clearLoginData({ commit, state }) {
    const globalParams = await SodaGlobalParams()
    const ticket = state.login.ticket
    storage.remove('ticket')
    storage.remove('uname')
    commit('updateLogin', {
      phone: '',
      token: '',
      userInfo: { feature_auth: {} }
    })
    if (window.SODA_RN) {
      request
        .get({
          url: 'common.logout',
          params: {
            ticket: ticket || globalParams.ticket,
            ...globalParams
          }
        })
        .finally(() => {
          window.Soda.requestLogout({}, () => {})
        })
    } else {
      if (window.Soda && window.Soda.removeTicket) {
        request
          .get({
            url: 'common.logout',
            params: {
              ticket: globalParams.ticket || ticket,
              ...globalParams
            }
          })
          .then((data = {}) => {
            window.Soda.removeTicket && window.Soda.removeTicket()
            if (data.data) {
              window.location.href = data.data.redirectUrl
            }
          })
      } else {
        window.location.href = prefixUrl(
          'common.logout',
          {
            ticket,
            ...globalParams
          },
          { isAddCommonParams: true }
        )
      }
    }
  },
  async initGeoData({ commit, rootState }) {
    async function _locate(commit) {
      const pos = await getLocation();
      pos.hasError = pos.hasError || false;
      commit('updateGeo', pos);
      // _nextLocate(commit); 
    }
  
    // function _nextLocate(commit) {
    //   const DELAY = 60 * 1000;
    //   window.setTimeout(() => {
    //     _locate(commit);
    //   }, DELAY);
    // }
  
    await _locate(commit);
  },


  initAreaData({ commit, getters }) {
    return new Promise((resolve, reject) => {
      api
        .getDefaultArea(getters.geo)
        .then(res => {
          return api.getLaunchCityList().then(obj => {
            let { current, selectOptions } = res.data
            function getTree(data) {
              return data
                .filter(d => {
                  const [type, id] = (d.id || '').split('|')
                  if (type !== 'bdCity') {
                    return true
                  }
                  return obj[id] != null
                })
                .map(v => {
                  const item = {
                    id: v.id,
                    label: v.label,
                    isAuth: v.isAuth
                  }
                  if (v.child.length > 0) {
                    item.child = getTree(v.child)
                  }
                  return item
                })
            }
            let result = getTree(selectOptions)
            commit('updateAreaGroup', current)
            commit('updateAreaSelections', result)
            resolve()
          })
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  showLoading({ commit }) {
    commit('toggleLoading', 1)
  },

  hideLoading({ commit }) {
    commit('toggleLoading', -1)
  },

  goto({ commit }, path) {
    commit('goto', path)
  },

  message({ commit }, message) {
    commit('message', message)
  },

  getShopCommonConfig({ commit, state }, payload) {
    return api
      .getShopCommonConfig({
        type: 'bankMap'
      })
      .then(res => {
        commit('setShopCommonConfig', res.data)
      })
  },
  recordBdSelectOption({ commit, state }, payload) {
    try {
      api.recordSelectOption(payload).then(res => {
        return true
      })
    } catch (e) {
      console.error(e)
      return false
    }
  },
  // 获取国家和语言信息
  getUserAuthCountry({ commit, state }, payload) {
    return api.getUserAuthCountry().then(res => {
      commit('setUserAuthCountry', res.data)
    })
  },
  getInWhiteList({ commit, state }) {
    return api.getInWhiteList().then(result => {
      commit('setInWhiteList', result)
    })
  }
}
